/**
 * Craft slugs → labels. The server is the source of truth (GET /pro/crafts/groups); this is
 * the fallback for a slug the client hasn't been told about yet, so a new craft still reads
 * as words instead of "av-sound-lighting".
 */
export const craftLabel = (slug) => (slug || '')
  .split('-')
  .map((w) => (w === 'dj' ? 'DJ' : w === 'mc' ? 'MC' : w === 'av' ? 'AV' : w.charAt(0).toUpperCase() + w.slice(1)))
  .join(' ');

/** Build a slug → label map from the grouped payload. */
export const labelMapFromGroups = (groups) => {
  const map = {};
  (groups || []).forEach((g) => (g.crafts || []).forEach((c) => { map[c.slug] = c.label; }));
  return map;
};
